import { ParticipantLandingPage } from "./pages/participantLandingPage";

export const routes = [
  {
    path: "/",
    Component: ParticipantLandingPage,
    exact: true,
    isPrivate: false,
  },
];
